import React from 'react';
import { useMediaQuery } from 'utils/hooks/useMediaQuery';
import { IColor } from 'utils/types/contentful';
import clsx from 'clsx';
import { Button } from '../../../Elements';

export interface DiopterPickerProps {
  diopters: string[];
  color: IColor;
}

export const DiopterPicker: React.FC<DiopterPickerProps> = ({
  variants,
  color,
  onDiopterChange,
  variant,
}) => {
  const isWindowSmallSize = useMediaQuery('sm');
  return (
    <ul className='flex flex-wrap'>
      {variants?.map((v, index) => {
        const isLastDiopter = index === variants.length - 1;
        const isSelected = variant.diopter === v.selectedOptions.diopter;
        const isSelectedDiopterAvailable = v.availableForSale;
        const buttonColor = isSelected
          ? !isSelectedDiopterAvailable
            ? { classname: 'gray-300' }
            : color
          : { classname: 'white' };
        const buttonLabelColor = !isSelectedDiopterAvailable && {
          classname: 'gray-400',
        };

        const buttonLabel = {
          text: v.selectedOptions.diopter,
          color: buttonLabelColor,
        };

        return (
          <li className={clsx(`${!isLastDiopter && 'mr-2'}`, 'mb-1')}>
            <Button
              color={buttonColor}
              isCrossed={!isSelectedDiopterAvailable}
              label={buttonLabel}
              onClick={() => onDiopterChange(v.selectedOptions.diopter)}
              size={isWindowSmallSize ? 'base' : 'sm'}
              type='contained'
            />
          </li>
        );
      })}
    </ul>
  );
};
